import { render, staticRenderFns } from "./Nonconformance.vue?vue&type=template&id=4ec0d8f2"
import script from "./Nonconformance.vue?vue&type=script&lang=js"
export * from "./Nonconformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports